import { cn } from '@/lib/utils';
import { ROTULO_STATUS } from '@/components/orcamento/tipos';
import type { StatusOrcamento } from './tipos';

const ESTILO: Record<StatusOrcamento, string> = {
  RASCUNHO: 'bg-line-soft text-ink-body',
  ENVIADO: 'bg-blue-100 text-blue-800',
  EM_NEGOCIACAO: 'bg-purple-100 text-purple-800',
  APROVADO: 'bg-success-bg text-success-ink',
  PERDIDO: 'bg-danger-bg text-danger-ink',
};

/** Situacao do orcamento (pill). Cores do design (Orcamentos.dc.html). */
export function StatusBadge({ status, className }: { status: StatusOrcamento; className?: string }) {
  return (
    <span data-status={status} className={cn('inline-flex rounded-full px-2.5 py-0.5 text-caption font-semibold', ESTILO[status], className)}>
      {ROTULO_STATUS[status]}
    </span>
  );
}
